import _ from "lodash";
import { RadioButton, RadioButtonGroup } from "material-ui";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import MultiSelect, {
  MultiSelectOption,
} from "../../../core/modules/common/components/MultiSelect";
import OPERATORS from "../constants/operators";
import { sortRowValues } from "../helpers/sortValues";
import ColumnFilter from "./ColumnFilter";

const initialCurrent = {
  operator: OPERATORS.CONTAINS,
  string: "",
  valid: false,
};

class TextFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelectOptions: this.getOrderedUniqueValues(props),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      this.setState({
        multiSelectOptions: this.getOrderedUniqueValues(nextProps),
      });
    }
  }

  getOrderedUniqueValues = (props) =>
    _(props.data)
      .map((row) => {
        const value = props.column.accessor(row);
        if (
          !value ||
          value === "" ||
          (Array.isArray(value) && value.length === 0)
        ) {
          return new MultiSelectOption(null, "(Blank)");
        }

        if (Array.isArray(value) && value.length) {
          return value.map((v) => new MultiSelectOption(v));
        }

        return new MultiSelectOption(value);
      })
      .flatten()
      .uniqBy("value")
      .value()
      .sort(sortRowValues);

  isValid = (multiSelectValues, string) => {
    return (multiSelectValues && multiSelectValues.length > 0) || !!string;
  };

  render() {
    return (
      <ColumnFilter
        {...this.props}
        render={(current = initialCurrent, setCurrent) => {
          const handleChangeMultiSelect = (value) => {
            setCurrent({
              ...current,
              multiSelectValues: value,
              valid: this.isValid(value, current.string),
            });
          };

          const handleRadioChange = (_, operator) => {
            const isBlankOperator = operator === OPERATORS.NOT_BLANKS;

            setCurrent({
              ...current,
              valid:
                isBlankOperator || this.isValid(current.value, current.string),
              operator,
            });
          };

          const handleInputChange = (event) => {
            const isBlankOperator = current?.operator === OPERATORS.NOT_BLANKS;

            setCurrent({
              ...current,
              string: event.target.value,
              valid:
                isBlankOperator ||
                this.isValid(current.multiSelectValues, event.target.value),
            });
          };

          return (
            <div>
              <div className="advanced-filter__fields">
                <MultiSelect
                  value={current.multiSelectValues}
                  onChange={handleChangeMultiSelect}
                  options={this.state.multiSelectOptions}
                />
              </div>
              <div className="advanced-filter__fields">
                <RadioButtonGroup
                  onChange={handleRadioChange}
                  name="textFilter"
                  valueSelected={current.operator}
                >
                  <RadioButton
                    value={OPERATORS.CONTAINS}
                    label={
                      <FormattedMessage id="filter-component.label.contains" />
                    }
                  />
                  <RadioButton
                    value={OPERATORS.STARTS_WITH}
                    label={
                      <FormattedMessage id="filter-component.label.starts-with" />
                    }
                  />
                  <RadioButton
                    value={OPERATORS.NOT_STARTS_WITH}
                    label="Not Starts With"
                  />
                  <RadioButton
                    value={OPERATORS.NOT_INCLUDE}
                    label="Not include"
                  />
                  <RadioButton
                    value={OPERATORS.NOT_BLANKS}
                    label="Except blanks"
                  />
                </RadioButtonGroup>
              </div>

              <div className="advanced-filter__fields">
                {current.operator !== OPERATORS.NOT_BLANKS && (
                  <input
                    className="text-input"
                    onChange={handleInputChange}
                    value={current.string}
                  />
                )}
              </div>
            </div>
          );
        }}
      />
    );
  }
}

TextFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export default TextFilter;
